module.exports = __webpack_public_path__ + "img/icon_zuixiao.4f04005b.svg";